import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material";
import Alert from "@mui/material/Alert";
import PropTypes from "prop-types";
import React from "react";
import ConfirmButton from "./ConfirmButton";
import SlideUpTransition from "./SlideUpTransition";

const WarningDialog = (props) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: props.width || "500px",
          maxWidth: "90vw",
          margin: "auto",
          whiteSpace: "pre-line",
        },
      }}
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      onClose={props.handleClickDialogClose}
    >
      <DialogTitle id="alert-dialog-slide-title">{props.header}</DialogTitle>
      <DialogContent>
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            <Grid item xs={12}>
              <Alert severity={`${props.severity}`}>{props.message}</Alert>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ConfirmButton variant="contained" color="primary" onClick={props.handleClickDialogClose}>
          OK
        </ConfirmButton>
      </DialogActions>
    </Dialog>
  );
};

WarningDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  handleClickDialogClose: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  severity: PropTypes.string.isRequired,
  width: PropTypes.string,
};

export default WarningDialog;
